'use client';

import { Button, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { InverseButton } from '@parkchirp/ui-library';
import React, { Dispatch, FC, SetStateAction } from 'react';

import { SalesLimit } from '../../../types';

interface Props {
	setTabValue: Dispatch<SetStateAction<string>>;
	monthsInAdvance: number;
	setMonthsInAdvance: Dispatch<SetStateAction<number>>;
	setSalesLimits: Dispatch<SetStateAction<SalesLimit[]>>;
	salesLimits: SalesLimit[];
	setActiveStep: Dispatch<SetStateAction<number>>;
	isChild: boolean;
	theme: any;
}

const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const Sales: FC<Props> = ({
	setTabValue,
	monthsInAdvance,
	setMonthsInAdvance,
	setSalesLimits,
	salesLimits,
	setActiveStep,
	isChild,
	theme,
}) => {
	const handleNext = () => {
		setTabValue(isChild ? '7' : '6');
		setActiveStep(isChild ? 6 : 5);
	};

	const handleSalesLimitChange = (value, index, param) => {
		let newValue;
		if (!value) {
			newValue = 0;
		} else {
			newValue = value;
		}
		salesLimits[index][param] = newValue;
		setSalesLimits([...salesLimits]);
	};

	return (
		<Grid spacing={2} container>
			<Grid item xs={12}>
				<InputLabel>
					Number of months to sell in advance<span className='pca__ratesForm-required'>*</span>
				</InputLabel>
				<Select
					fullWidth
					required
					value={monthsInAdvance}
					onChange={(e) => setMonthsInAdvance(Number(e.target.value))}
					data-cy='months-in-advance-select-menu'
				>
					{months.map((m, i) => (
						<MenuItem key={i} value={m}>
							{m}
						</MenuItem>
					))}
				</Select>
			</Grid>
			<Grid className='pca__ratesForm-containerPadding' container xs={12}>
				<Grid className='pca__ratesFormSales-salesCell pca__ratesForm-divider' item xs={2}>
					Month
				</Grid>
				<Grid className='pca__ratesFormSales-salesCell pca__ratesForm-divider' item xs={2}>
					Year
				</Grid>
				<Grid className='pca__ratesFormSales-salesCell pca__ratesForm-divider' item xs={2}>
					Sales Limit
				</Grid>
				<Grid className='pca__ratesFormSales-salesCell pca__ratesForm-divider' item xs={2}>
					Sold
				</Grid>
				<Grid className='pca__ratesFormSales-salesCell pca__ratesForm-divider' item xs={2}>
					Terminating
				</Grid>
				<Grid className='pca__ratesFormSales-salesCell pca__ratesForm-divider' item xs={2}>
					Total
				</Grid>
				{salesLimits.map((sl, index) => (
					<>
						<Grid className='pca__ratesFormSales-salesCell' item xs={2}>
							{sl.month}
						</Grid>
						<Grid className='pca__ratesFormSales-salesCell' item xs={2}>
							{sl.year}
						</Grid>
						<Grid className='pca__ratesFormSales-salesCell' item xs={2}>
							<TextField
								fullWidth
								value={sl.limit}
								onChange={(e) => handleSalesLimitChange(Number(e.target.value), index, 'limit')}
							/>
						</Grid>
						<Grid className='pca__ratesFormSales-salesCell' item xs={2} />
						<Grid className='pca__ratesFormSales-salesCell' item xs={2} />
						<Grid className='pca__ratesFormSales-salesCell' item xs={2} />
					</>
				))}
			</Grid>
			<Grid className='pca__ratesForm-containerPadding' spacing={2} container>
				<Grid item xs={6}>
					<InverseButton
						fullWidth
						onClick={() => {
							setTabValue(isChild ? '5' : '4');
							setActiveStep(isChild ? 4 : 3);
						}}
						data-cy='previous-button'
						name='Previous'
						theme={theme}
					/>
				</Grid>
				<Grid item xs={6}>
					<Button fullWidth onClick={handleNext} data-cy='next-step-button'>
						Next
					</Button>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Sales;
